
const consentButtons = document.querySelectorAll('.accept-consent');
consentButtons.forEach(button => {
    button.addEventListener('click', function () {
        const replaceTarget = document.querySelector(button.dataset.replace);
        const target = document.querySelector(button.dataset.target);

        if (replaceTarget && target) {
            replaceTarget.outerHTML = target.innerHTML;
        }
    })
})